import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {action, observable} from 'mobx';

/**
 * Create a wrapper composition to support hover enter/leave functionality
 * @param ComposedComponent
 * @returns {{Component}}
 */

export function withHover(ComposedComponent) {
    return @observer class extends Component {
        @observable isHovering = false;
        @observable timestamp = Date.now();

        @action onHoverLeave = () => {
            this.isHovering = false;
            this.timestamp = Date.now();
        };

        @action onHoverEnter = () => {
            this.isHovering = true;
            this.timestamp = Date.now();
        };

        render() {
            return <ComposedComponent
                {...this.props} timestamp={this.timestamp} isHovering={this.isHovering} onMouseLeave={this.onHoverLeave}
                onMouseOver={this.onHoverEnter}/>;
        }
};
}
